module.exports = __webpack_public_path__ + "img/DealerIcons-DataAcquisition-Off.569374e.jpg";